import isDomUsable from '@fenderdigital/dom';
import Cookie from '../lib/cookie';

const rawSiteId = process.env.REACT_APP_CLIENT_SITE_ID;
const siteId = rawSiteId[0].toUpperCase() + rawSiteId.slice(1);
const event = (type, properties, options, callback) => {
  if (isDomUsable() && window.analytics) {
    window.analytics.track(type, { siteId, ...properties }, options, callback);
  }
};

const pageTrack = (category, name, properties, options, callback) => {
  const updatedProperties = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    country_code: Cookie.getCountry(),
    ...properties,
    siteId,
  };
  console.log('trackPage', updatedProperties.path, window.location.href);

  if (window && window.analytics) {
    window.analytics.page(category, name, updatedProperties, options, callback);
  }
};

export function decorateWindow() {
  // eslint-disable-next-line no-multi-assign
  const analytics = (window.analytics = window.analytics || []);
  if (!analytics.initialize) {
    if (analytics.invoked) {
      if (window.console && console.error) {
        console.error('Segment snippet included twice.');
      }
    } else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
      ];
      analytics.factory = t => {
        return () => {
          // eslint-disable-next-line prefer-rest-params
          const e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        };
      };
      for (let t = 0; t < analytics.methods.length; t++) {
        const e = analytics.methods[t];
        analytics[e] = analytics.factory(e);
      }
      analytics.load = t => {
        const e = document.createElement('script');
        e.id = 'segment_analytics';
        e.type = 'text/javascript';
        e.async = !0;
        e.src = `${
          document.location.protocol === 'https:' ? 'https://' : 'http://'
        }cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
        const n = document.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(e, n);
      };
      analytics.SNIPPET_VERSION = '4.0.0';
    }
  }
}
export function loadSegment() {
  if (!window.analytics) {
    console.error('decorateWindow for sement should be called first');
    return;
  }
  window.analytics.load(`${process.env.REACT_APP_SEGMENT_KEY}`);
  window.analytics.page();
}

export default { pageTrack, event };
